import { z } from "zod";
import { AttributeSchema } from "./attribute";
import { ImageSchema } from "./image";

export const ProductItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  discount: z.number().nullable(),
  price: z.number(),
  inventory: z.number().nullable(),
  attributes: AttributeSchema.array().nullable(),
  images: ImageSchema.array(),
});
